import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/live-oak")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Live Oak, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Live Oak & Bexar County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Live Oak, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Live Oak and Bexar County.",
      keywords: "awnings Live Oak, awning company Live Oak, custom awnings Live Oak, sail shades Live Oak, patio covers Live Oak, pergola covers Live Oak, metal awnings Live Oak, canvas awnings Live Oak, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Live Oak", "Bexar County"),
  }),
  component: () => <CityHomePage city="Live Oak" region="Bexar County" />,
});
